import { render } from "./FloatBackToComponent.vue?vue&type=template&id=fc9785dc"
import script from "./FloatBackToComponent.vue?vue&type=script&lang=js"
export * from "./FloatBackToComponent.vue?vue&type=script&lang=js"

import "./FloatBackToComponent.vue?vue&type=style&index=0&id=fc9785dc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__